import { SupportedLanguages, TranslactionsModel } from './lang-settings';

import { rule } from './rule';
import { common } from './common';
import { error } from './error';
import { admissionMap } from './admissionMap';
import { procedureReport } from './procedureReport';
import { reports } from './reports';
import { historyModal } from './historyModal';
import { BIControlPanel } from './biControlPanel';
import { coparticipation } from './coparticipation';
import { integrationMonitoring } from './integrationMonitoring';

const supportedLanguages: SupportedLanguages[] = ['pt-BR', 'en-US'];

const langs: Record<string, TranslactionsModel> = Object.fromEntries(
  supportedLanguages.map(
    (lang): [string, TranslactionsModel] => [
      lang,
      {
        biControlPanel: BIControlPanel[lang],
        common: common[lang],
        error: error[lang],
        rule: rule[lang],
        admissionMap: admissionMap[lang],
        procedureReport: procedureReport[lang],
        integrationMonitoring: integrationMonitoring[lang],
        reports: reports[lang],
        historyModal: historyModal[lang],
        coparticipation: coparticipation[lang],
      },
    ],
  ),
);

export default langs;
